export default __webpack_public_path__ + "static/media/ac_idch.3b0d397e.bmp";